/**
 * ==========================================
 * Local Development
 * ==========================================
 */

// export const api_url = "http://localhost:3001/api/";
// export const img_url = "http://localhost:3001/";
// export const socket_url = "http://localhost:3001";
// export const web_url = "http://localhost:3001";

/**
 * ==========================================
 * Development Server
 * ==========================================
 */

// export const api_url = "https://dev-api.smindiagroup.com/api/";
// export const img_url = "https://dev-api.smindiagroup.com/";
// export const socket_url = "https://dev-api.smindiagroup.com";
// export const web_url = "https://dev.smindiagroup.com";

/**
 * ==========================================
 * Production Server (Current)
 * ==========================================
 */

export const api_url = "https://api.smindia2050.com/api/";
export const img_url = "https://api.smindia2050.com/";
export const socket_url = "https://api.smindia2050.com";
export const web_url = "https://smindia2050.com";

/**
 * ==========================================
 * Legacy / Backup URLs
 * ==========================================
 */

// export const api_url = "http://52.66.11.219:80/api/";
// export const api_url = "https://api.smindiagroup.com/api/";
// export const img_url = "https://api.smindiagroup.com/api/";
// export const api_url = "https://api.smindiagroup.com/";
